<template>
    <div>

        <DataTable
            :header="$t('shopLocations')"
            :fields="fields"
            :items="parentComponent.items"
            :loading="parentComponent.loading"
            :error="parentComponent.error"
            :total-rows="parentComponent.requestData.max"
            :current-page.sync="parentComponent.tableParams.page"
            :per-page.sync="parentComponent.tableParams.perPage"
            :sort-by.sync="parentComponent.tableParams.sort"
            :sort-direction.sync="parentComponent.tableParams.order"
            no-sort-reset
            no-local-sorting
        >

            <template #headerSide>
                <ButtonIcon
                    class="ml-2"
                    icon="plus"
                    variant="primary"
                    :disabled="parentComponent.loading"
                    @click="editItem()"
                >
                    {{ $t('addNew') }}
                </ButtonIcon>
            </template>

            <template #cell(hide)="{value}">
                <BadgeBoolean :value="value" true-value-badge-variant="danger" false-value-badge-variant="success" />
            </template>

            <template #cell(action)="{item}">
                <div class="d-flex gap-1 justify-content-end">
                    <ButtonIcon
                        size="sm"
                        icon="edit-2"
                        variant="primary"
                        :disabled="requestOfflineLocation.getLoading(`delete-${item.id}`)"
                        :loading="requestOfflineLocation.getLoading(`edit-${item.id}`)"
                        @click="editItem(item)"
                    />
                    <ButtonIcon
                        size="sm"
                        icon="trash-2"
                        variant="danger"
                        :disabled="requestOfflineLocation.getLoading(`edit-${item.id}`)"
                        :loading="requestOfflineLocation.getLoading(`delete-${item.id}`)"
                        @click="deleteItem(item)"
                    />
                </div>
            </template>

        </DataTable>

        <ModalForm />

    </div>
</template>



<script>
    import DataTable from '@/components/common/DataTable.vue';
    import BadgeBoolean from '@/components/common/BadgeBoolean.vue';
    import ModalForm from './parts/ModalForm.vue';

    export default {
        name: 'Results',
        components: {
            DataTable,
            BadgeBoolean,
            ModalForm,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                requestOfflineLocation: this.$req('campaigns/offlineLocation'),
                campaignId: Number.parseInt(this.$route.params.id),
            };
        },
        computed: {
            fields() {
                return [
                    { key: 'id', label: this.$t('id'), sortable: true },
                    { key: 'code', label: this.$t('code'), sortable: true },
                    { key: 'name', label: this.$t('name'), sortable: true },
                    { key: 'city', label: this.$t('city'), sortable: true },
                    { key: 'address', label: this.$t('address') },
                    { key: 'zip', label: this.$t('postcode') },
                    { key: 'hide', label: this.$t('hidden'), sortable: true },
                    { key: 'campaign.name', label: this.$t('campaign') },
                    { key: 'latitude', label: this.$t('latitude') },
                    { key: 'longitude', label: this.$t('longitude') },
                    { key: 'action', label: '', tdClass: 'text-right', thClass: 'text-right' },
                ];
            },
        },
        methods: {
            deleteItem(item) {
                this.$bvModal
                    .msgBoxConfirm(this.$t('confirmYouWantDelete'), {
                        title: this.$t('confirm'),
                        okTitle: this.$t('yes'),
                        cancelTitle: this.$t('cancel'),
                        okVariant: 'danger',
                    })
                    .then(value => {
                        if (value) {
                            this.requestOfflineLocation
                                .id(`delete-${item.id}`)
                                .delete({ urlParams: { campaignId: this.campaignId, locationId: item.id } })
                                .then(this.parentComponent.fetchData)
                                .catch(error => this.$toastr.error(error.message, this.$t('errorOccurred')));
                        }
                    });
            },
            editItem(item = null) {
                this.$root.$emit('bv::show::modal', 'modal-form-campaign-offline-location');
                this.$root.$emit('modal-form-campaign-offline-location', item);
            },
        },
    };
</script>
